import { useParams, matchPath, useLocation } from "react-router-dom";
import { useContractDetails } from "../../../../api/hooks/useContractDetails";
import {
  CONTRACT_ADHOC_INVOICES_PATH,
  CONTRACT_INVOICES_PATH,
  CONTRACT_PAYMENTS_PATH,
  CONTRACTS_DETAIL_PATH,
  CONTRACTS_PATH,
} from "../../../../paths";
import { BreadcrumbItem } from "../../../../shared/breadcrumbs/BreadcrumbContext";
import { partition } from "lodash";
import { CONTRACT_UNAPPROVED_ADHOC_TITLE } from "../fields/ContractActionsCell";

export const useContractLinks = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  const { contract, isPending, isFetching, refetch, queryKey } = useContractDetails({ id });

  const links: BreadcrumbItem[] = [
    {
      label: "Contracts",
      path: CONTRACTS_PATH,
    },
  ];

  if (id && contract) {
    links.push(
      {
        label: contract.contract_display_name,
        path: CONTRACTS_DETAIL_PATH,
        menu: true,
        menuLabel: "Contract",
        params: {
          id,
        },
      },
      {
        label: "Payments",
        menu: true,
        path: CONTRACT_PAYMENTS_PATH,
        params: {
          id,
        },
      },
      {
        label: "Invoices",
        menu: true,
        path: CONTRACT_INVOICES_PATH,
        params: {
          id,
        },
      },
      {
        label: "Adhoc Invoices",
        menu: true,
        menuLabel: "Adhoc",
        title:
          contract.unapproved_additional_charges && contract.unapproved_additional_charges > 0
            ? CONTRACT_UNAPPROVED_ADHOC_TITLE
            : undefined,
        badge: contract.unapproved_additional_charges || null,
        badgeColor: "warning",
        path: CONTRACT_ADHOC_INVOICES_PATH,
        params: {
          id,
        },
      },
    );
  }

  const [matchedLinks, unmatchedLinks] = partition(links, (link) =>
    "to" in link
      ? matchPath({ path: link.to, end: false }, pathname)
      : matchPath({ path: link.path, end: false }, pathname),
  );

  return {
    id,
    contract,
    refetch,
    queryKey,
    isPending,
    isFetching,
    links,
    matchedLinks,
    unmatchedLinks,
    menuLinks: links
      .filter(({ menu }) => menu)
      .map(({ menuLabel, ...rest }) => ({ ...rest, label: menuLabel || rest.label })),
  };
};
